import { mapGetters } from 'vuex'
import config from '@/common/config'
import MediaQueryBreakPoints from '@/constants/core/MediaQueryBreakPoints'

export default {
  computed: {
    ...mapGetters({
      isDebug: 'isDebugModeActive',
      isEmbedded: 'isEmbedded',
      isDarkMode: 'isDarkModeActive',
    }),
    isExtraSmall() {
      return this.$mq === MediaQueryBreakPoints.xs.code
    },
    isSmall() {
      return this.$mq === MediaQueryBreakPoints.sm.code
    },
    isMedium() {
      return this.$mq === MediaQueryBreakPoints.md.code
    },
    isLarge() {
      return this.$mq === MediaQueryBreakPoints.lg.code
    },
    isExtraLarge() {
      return this.$mq === MediaQueryBreakPoints.xl.code
    },
    isSmallOrLower() {
      return this.isSmall || this.isExtraSmall
    },
    isMediumOrLower() {
      return this.isSmall || this.isExtraSmall || this.isMedium
    },
    isLargeOrLower() {
      return this.isSmall || this.isExtraSmall || this.isMedium || this.isLarge
    },
    isSmallOrHigher() {
      return this.isSmall || this.isMedium || this.isLarge || this.isExtraLarge
    },
    isMediumOrHigher() {
      return this.isMedium || this.isLarge || this.isExtraLarge
    },
    isLargeOrHigher() {
      return this.isLarge || this.isExtraLarge
    },
    isMobileViewPort() {
      return this.$mq === 'sm' || this.$mq === 'xs'
    },
    isDev() {
      return config.get('env') === 'development'
    },
    reliefRosterUrl() {
      return config.get('reliefRosterUrl')
    },
  },
  methods: {
    setTheme() {
      if (this.isDarkMode) {
        return (this.$vuetify.theme.dark = true)
      } else {
        return (this.$vuetify.theme.dark = false)
      }
    },
    returnCandidateUrl(candidateId) {
      return `${this.reliefRosterUrl}/candidate/details/${candidateId}`
    },
    returnBookingUrl(bookingId) {
      return `${this.reliefRosterUrl}/booking/bookingView/${bookingId}`
    },
    returnClientUrl(clientId) {
      return `${this.reliefRosterUrl}/client/viewClient/${clientId}`
    },
    returnClientGroupUrl(groupId) {
      return `${this.reliefRosterUrl}/client/viewGroup/${groupId}`
    },
    returnLocationUrl(clientId, locationId) {
      return `${this.returnClientUrl(clientId)}#location_${locationId}`
    },
  },
}
